import React, { useState, useEffect, useRef } from 'react'; // Import useRef
import PhotoSwipe from 'photoswipe';
import 'photoswipe/dist/photoswipe.css';
import 'photoswipe/style.css';
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';

const GalleryComponent = ({ images, videoThumbnail, gallery_id }) => {
  // eslint-disable-next-line no-unused-vars
  const [l, setLightbox] = useState(null);
  const lightboxRef = useRef(null); // Use useRef to hold the lightbox instance

  useEffect(() => {
    // Only initialize PhotoSwipeLightbox on the client side
    if (typeof window !== 'undefined') {
      const lightbox = new PhotoSwipeLightbox({
        gallery: '#' + gallery_id,
        children: 'a',
        pswpModule: PhotoSwipe,
      });

      lightbox.addFilter('itemData', (itemData) => {
        const localVideoUrl = itemData.element.dataset.localVideoUrl;
        if (localVideoUrl) {
          itemData.localVideoUrl = localVideoUrl;
        }
        return itemData;
      });

      lightbox.on('contentLoad', (e) => {
        const { content } = e;
        if (content.type === 'local-video') {
          e.preventDefault();
          content.element = document.createElement('div');
          content.element.className = 'pswp__video-container';

          const video = document.createElement('video');
          video.setAttribute('controls', true);
          video.setAttribute('width', '80%');
          video.setAttribute('height', 'auto');
          const source = document.createElement('source');
          source.type = 'video/mp4';
          source.src = flattenToAppURL(
            content.data.localVideoUrl.includes('/@@download/file')
              ? content.data.localVideoUrl
              : `${content.data.localVideoUrl}/@@download/file`,
          );
          video.appendChild(source);
          content.element.appendChild(video);
        }
      });

      lightbox.init();
      setLightbox(lightbox);
      lightboxRef.current = lightbox; // Store in ref for cleanup
    }

    return () => {
      if (lightboxRef.current) {
        lightboxRef.current.destroy();
        lightboxRef.current = null;
      }
    };
  }, [gallery_id]); // Add gallery_id to dependencies, although it's constant here

  return (
    <React.Fragment>
      {images?.map((image, index) => (
        <React.Fragment key={index}>
          {image?.image_scales ? (
            <a
              href={`${
                image['@id'] +
                '/' +
                (image?.image_scales?.image?.[0]?.scales?.larger?.download
                  ? image?.image_scales?.image?.[0]?.scales?.larger?.download
                  : image.image_scales.image[0]?.download)
              }`}
              data-pswp-width={
                image?.image_scales?.image?.[0]?.scales?.larger?.width
                  ? image?.image_scales?.image?.[0]?.scales?.larger?.width
                  : image.image_scales.image[0].width
              }
              data-pswp-height={
                image?.image_scales?.image?.[0]?.scales?.larger?.height
                  ? image?.image_scales?.image?.[0]?.scales?.larger?.height
                  : image.image_scales.image[0].height
              }
              key={index}
              target="_blank"
              rel="noreferrer"
            >
              <img
                src={`${
                  image['@id'] +
                  '/' +
                  (image?.image_scales?.image?.[0]?.scales?.preview?.download
                    ? image?.image_scales?.image?.[0]?.scales?.preview?.download
                    : image.image_scales.image[0].scales.mini?.download)
                }`}
                alt=""
                loading="lazy"
              />
            </a>
          ) : (
            <a
              href="#video"
              data-pswp-type="local-video"
              data-local-video-url={image['@id']}
            >
              <img
                src={videoThumbnail}
                alt=" description"
                className="img-responsive"
              />
            </a>
          )}
        </React.Fragment>
      ))}
    </React.Fragment>
  );
};

export default GalleryComponent;
